import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import Reveal from '../common/Reveal';
import FaqList from './FaqList';
import { SITE } from '../../config/site';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

export default function Faq() {
  const { t } = useLang();
  const f = t.faq;
  usePageTitle(f.pageTitle);

  return (
    <>
      <PageHeader crumb={f.pageTitle} eyebrow={f.eyebrow} title={f.title} />
      <section className="section">
        <div className="container narrow">
          {f.groups.map((g, gi) => (
            <Reveal key={g.title} className="faq-group">
              <h2 className="faq-group__title">
                <i className={`fa-solid ${gi === 0 ? 'fa-shield-halved' : 'fa-code'}`} aria-hidden="true" /> {g.title}
              </h2>
              <FaqList items={g.items} idPrefix={`g${gi}`} defaultOpen={gi === 0 ? 0 : -1} />
            </Reveal>
          ))}

          <Reveal className="still">
            <div>
              <h3>{f.stillTitle}</h3>
              <p>{f.stillText}</p>
            </div>
            <div className="still__actions">
              {SITE.whatsapp ? (
                <a href={SITE.whatsapp} className="btn btn--outline" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-whatsapp" aria-hidden="true" /> {t.contact.info.whatsapp}
                </a>
              ) : (
                <a href={`mailto:${SITE.email}`} className="btn btn--outline">
                  <i className="fa-solid fa-envelope" aria-hidden="true" /> {t.contact.info.email}
                </a>
              )}
              <Link to="/contact?topic=general" className="btn btn--primary">
                {t.common.talkToUs}
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
